export default "__VITE_ASSET__jnQ2Vtdg__"